import StoreInfo from '@common/models/StoreInfo';
import { RootState } from '@common/store';
import {
  addProductToCart,
  CartSliceType,
  removeProductFromCart,
  setProductQuantityInCart,
  subtractProductFromCart,
} from '@common/store/cart/slice';
import { CategoriesSliceType } from '@common/store/categories/slice';
import { FeaturesSliceType } from '@common/store/features/slice';
import { fetchPageHeaderRequest, PageHeaderSliceType } from '@common/store/pageHeader/slice';
import { fetchProductsRequest } from '@common/store/products/slice';
import { fetchSearchRequest, SearchSliceType } from '@common/store/search/slice';
import { UserProfileSliceType } from '@common/store/userProfile/slice';
import loadable from '@loadable/component';
import { DEFAULT_NAVBAR_LAYOUT_SELECTION } from '@theme/utils/constants';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { ADD_NEW_SECTION_ID } from '../../common/utils/constants';

export interface NavbarLayoutProps {
  userProfile: UserProfileSliceType;
  cart: CartSliceType;
  storeInfo: StoreInfo;
  features: FeaturesSliceType;
  addProductToCart: typeof addProductToCart;
  subtractProductFromCart: typeof subtractProductFromCart;
  setProductQuantityInCart: typeof setProductQuantityInCart;
  removeProductFromCart: typeof removeProductFromCart;
  fetchSearchRequest: typeof fetchSearchRequest;
  fetchProductsRequest: typeof fetchProductsRequest;
  search: Record<string, SearchSliceType>;
  categories: CategoriesSliceType;
  fetchPageHeaderRequest: fetchPageHeaderRequest.type;
  pageHeader: PageHeaderSliceType;
  id: string;
  layoutName: string;
}

interface NavBarState {
  ViewCart: boolean;
}

const Navbar1_4_7_15 = loadable(() => import('./Navbar1_4_7_15'));
const Navbar2_12 = loadable(() => import('./Navbar2_12'));
const Navbar3_5 = loadable(() => import('./Navbar3_5'));
const Navbar4_6_11_14_18 = loadable(() => import('./Navbar4_6_11_14_18'));
const Navbar5_3 = loadable(() => import('./Navbar5_3'));
const Navbar6_1_13 = loadable(() => import('./Navbar6_1_13'));
const Navbar7_8_9_16_17 = loadable(() => import('./Navbar7_8_9_16_17'));
const Navbar8_2_10_19 = loadable(() => import('./Navbar8_2_10_19'));

class Navbar extends PureComponent<NavbarLayoutProps, NavBarState> {
  constructor(props) {
    super(props);
    const { fetchPageHeaderRequest, id, pageHeader } = this.props;
    if (!pageHeader[id]?.isFetched && !pageHeader[id]?.isFetching && id !== ADD_NEW_SECTION_ID) {
      fetchPageHeaderRequest(id);
    }
    this.state = { ViewCart: false };
  }
  render(): React.ReactElement {
    const { pageHeader, id, storeInfo } = this.props;
    const layoutName = pageHeader[id]?.layout?.name || DEFAULT_NAVBAR_LAYOUT_SELECTION;
    const commonProps = {
      ...this.props,
      storeInfo: storeInfo.storeInfo,
      storeType: storeInfo.storeInfo?.storeType,
      isPaymentsDisabled: !storeInfo.storeInfo?.paymentsAllowed || !storeInfo.storeInfo?.isCodEnabled,
      isStoreInfoFetching: storeInfo.isFetching,
      ViewCart: this.state.ViewCart,
      id: id,
      setViewCart: () => {
        this.setState({ ViewCart: false });
      },
    };
    return (
      <div>
        {pageHeader[id] && layoutName ? (
          <>
            {layoutName === 'PH1' ? (
              <Navbar1_4_7_15 fallback={<Fallback />} {...commonProps} pageHeader={pageHeader[id]?.pageHeader} />
            ) : null}
            {layoutName === 'PH2' ? (
              <Navbar2_12 fallback={<Fallback />} {...commonProps} pageHeader={pageHeader[id]?.pageHeader} />
            ) : null}
            {layoutName === 'PH3' ? (
              <Navbar3_5 fallback={<Fallback />} {...commonProps} pageHeader={pageHeader[id]?.pageHeader} />
            ) : null}
            {layoutName === 'PH4' ? (
              <Navbar4_6_11_14_18 fallback={<Fallback />} {...commonProps} pageHeader={pageHeader[id]?.pageHeader} />
            ) : null}
            {layoutName === 'PH5' ? (
              <Navbar5_3 fallback={<Fallback />} {...commonProps} pageHeader={pageHeader[id]?.pageHeader} />
            ) : null}
            {layoutName === 'PH6' ? (
              <Navbar6_1_13 fallback={<Fallback />} {...commonProps} pageHeader={pageHeader[id]?.pageHeader} />
            ) : null}
            {layoutName === 'PH7' ? (
              <Navbar7_8_9_16_17 fallback={<Fallback />} {...commonProps} pageHeader={pageHeader[id]?.pageHeader} />
            ) : null}
            {layoutName === 'PH8' ? (
              <Navbar8_2_10_19 fallback={<Fallback />} {...commonProps} pageHeader={pageHeader[id]?.pageHeader} />
            ) : null}
          </>
        ) : null}
      </div>
    );
  }
}

const Fallback = () => {
  return <div></div>;
};

export default connect(
  ({ pageHeader, cart, products, features, storeInfo, search, userProfile, categories }: RootState) => ({
    pageHeader,
    cart,
    products,
    features,
    storeInfo,
    search,
    userProfile,
    categories,
  }),
  {
    fetchPageHeaderRequest,
    addProductToCart,
    removeProductFromCart,
    subtractProductFromCart,
    fetchSearchRequest,
    setProductQuantityInCart,
    fetchProductsRequest,
  },
)(Navbar);
